
    <div class="container">
      <div class="mat-title">{{ 'locations' | translate | titlecase }}</div>

      <ml-select-locations-table
        *ngIf="locations && selectedLocations"
        [locations]="locations"
        [selectedLocations]="selectedLocations"
        [disableSelect]="disableSelect"
        (addLocations)="onAddLocations($event)"
        (removeLocations)="onRemoveLocations($event)"
      ></ml-select-locations-table>

      <div
        *ngIf="loading"
        fxLayout
        fxLayoutAlign="center center"
        class="padding-16"
      >
        <mat-spinner diameter="48"></mat-spinner>
      </div>

      <div fxLayout fxLayoutAlign="end" class="margin-top-16">
        <button mat-button (click)="onClose()">
          {{ 'cancel' | translate | titlecase }}
        </button>
      </div>
    </div>
  